import {
  useChatChannelSocketEvents,
  useChatChatroomSocketEvents,
  useChatMessageSocketEvents,
  useFlightRoomSocketEvents,
  useNotificationSocketEvents,
  useTaskSocketEvents,
  useUserSocketEvents,
} from '../socketEvents';

export const useSocketEventsOrchestration = () => {
  useChatMessageSocketEvents();
  useChatChannelSocketEvents();
  useChatChatroomSocketEvents();
  useFlightRoomSocketEvents();
  useNotificationSocketEvents();
  useTaskSocketEvents();
  useUserSocketEvents();
};
